import { AnketaCopyModal } from './AnketaCopyModal'

export default AnketaCopyModal;